/* NOTICE — slash pricing (snippets/notice-slash-price.liquid). Loaded only where the 'price' block
   has "Slash pricing" ticked.

   The PDP price needs no help here: on variant change product-info.js copies the freshly rendered
   #price-<section> HTML (struck price and saving included) into both price copies. This file only
   keeps the struck price and the saving in the sticky add-to-cart bars in step, because those bars
   sit outside product-info and their price text is rewritten by product-info.js and
   notice-sticky-atc.js.

   1. product-info publishes variantChange (pub/sub) with the section HTML it has just fetched for the
      chosen variant. The struck amount there was worked out in Liquid, so it is copied across rather
      than recomputed (same rule as assets/notice-coupon.js).
   2. The DOM 'variant:change' event fires first, and also on an unavailable option combination where
      no pub/sub event follows. If that variant is not on sale (or there is none), hide the struck
      price at once; step 1 shows it again when the fresh HTML says so. */
(function () {
  function stickyWas() {
    return document.querySelectorAll('[data-nt-slash-sticky-was]');
  }

  // root: an element (or Document) holding a rendered price block; null hides the sticky struck price
  function syncSticky(root) {
    var source = root ? root.querySelector('[data-nt-slash-was]') : null;
    var saveSource = root ? root.querySelector('[data-nt-slash-save]') : null;
    stickyWas().forEach(function (el) {
      var amount = el.querySelector('[data-nt-slash-sticky-amount]');
      var save = el.querySelector('[data-nt-slash-sticky-save]');
      if (source && amount) {
        amount.innerHTML = source.innerHTML;
        if (save) save.innerHTML = saveSource ? saveSource.innerHTML : '';
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  function onSale(variant) {
    return !!(
      variant &&
      variant.available &&
      variant.compare_at_price != null &&
      Number(variant.compare_at_price) > Number(variant.price)
    );
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail ? event.detail.variant : null;
    if (!onSale(variant)) syncSticky(null);
  });

  function subscribeToVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.sectionId) return;
      var fresh = data.html && typeof data.html.getElementById === 'function'
        ? data.html.getElementById('price-' + data.sectionId)
        : null;
      syncSticky(fresh || document.getElementById('price-' + data.sectionId));
    });
    return true;
  }

  if (!subscribeToVariantChange()) {
    document.addEventListener('DOMContentLoaded', subscribeToVariantChange, { once: true });
  }
})();
